export enum WorkflowTypeEnum {
    BUY_GIFT_CARD = "BUY_GIFT_CARD",
    REGIFT_CARD = "REGIFT_CARD",
    ACTIVATE_GIFTCARD = "ACTIVATE_GIFTCARD"
}